import { render, staticRenderFns } from "./Paraph.vue?vue&type=template&id=c7f8ae1a"
import script from "./Paraph.vue?vue&type=script&lang=js"
export * from "./Paraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports